export var cifMl = ["301 201", "<g fill='none'><path fill='#14B53A' d='M.5.5h100v200H.5z'/><path fill='#FCD116' d='M100.5.5h100v200h-100z'/><path fill='#CE1126' d='M200.5.5h100v200h-100z'/></g>"];
